<template>
  <div class="po-r w100" v-loading="loading">
    <el-table class="w100 tx-c my-table" :data="list" stripe :show-header="false" :row-class-name="readState" cell-class-name="cu-p" :cell-style="{ 'border-bottom': 'none' }" @row-click="clickRow" height="390px">
      <el-table-column label="服务名称" prop="processName"></el-table-column>
      <el-table-column label="服务名称" prop="processTitle"></el-table-column>
      <!-- <el-table-column prop="step">
        <template slot-scope="scope">
          【{{ scope.row.processName }}】{{ scope.row.processTitle }}
        </template>
      </el-table-column> -->
      <el-table-column align="center" label="发起人" prop="createUserName" width="100px"></el-table-column>
      <el-table-column align="center" prop="step" width="180px">
        <template slot-scope="scope">
          {{ scope.row.createTime | filterDate('yyyy-MM-dd hh:mm:ss') }}
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="优先级" prop="rank" width="100px"></el-table-column> -->
    </el-table>
    <div class="w100 mt20 tx-r">
      <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[10, 20, 30, 50, 100]" :page-size="size" layout="total, prev, pager, next, jumper" background :total="total"></el-pagination>
    </div>
    <el-dialog :visible.sync="isShow" width="1000px" top="10px" :close-on-click-modal="false">
      <iframe ref="iframe" class="iframe" :src="isShow ? iframeUrl : ''"></iframe>

      <ProcessDialog ref="processDialog" />
    </el-dialog>
  </div>
</template>

<script>
import { clearTimeout } from "timers";
import { constants } from "crypto";
import ProcessDialog from "@/components/Public/ProcessDialog";

export default {
  name: "CardMyOfficeWDDB",
  components: {
    ProcessDialog,
  },
  props: {},
  data() {
    return {
      loading: false,

      label: [],
      list: [],
      page: 1,
      size: 10,
      total: 0,

      isShow: false,
      iframeUrl: "",

      loopTime: null,
    };
  },
  computed: {},
  mounted() {
    this.initPage();
  },
  destroyed() {
    if (this.loopTime) {
      window.clearTimeout(this.loopTime);
    }
  },
  methods: {
    loopInitPage() {
      if (this.loopTime) {
        window.clearTimeout(this.loopTime);
      }
      this.loopTime = setTimeout(() => {
        this.fetchList();
      }, 60000);
    },
    fetchList() {
      this.loading = true;
      this.loopInitPage();

      this.$http
        .post(
          "/newTask/undoPage",
          this.$qs.stringify({
            pageNum: this.page,
            pageSize: this.size,
          })
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.RetCode) {
            this.list = data.RetData.list;
            this.total = data.RetData.total;
          } else {
            this.$notify({
              title: "温馨提示",
              message: data.RetMsg,
              type: "error",
              offset: 60,
              duration: 3000,
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$notify({
            title: "温馨提示",
            message: "网络连接错误，请检查网络",
            type: "error",
            offset: 60,
            duration: 3000,
          });
          this.loading = false;
        });
    },
    initPage() {
      this.list = [];
      this.page = 1;
      this.fetchList();
    },
    clickRow(item) {
      this.iframeUrl = item.taskUrl + "&time=" + new Date().getTime();
      this.isShow = true;

      this.$nextTick(() => {
        window.addEventListener("message", (e) => {
          if (e.data.iframeHide) {
            this.isShow = false;
            this.iframeUrl = "";
          } else if (e.data.act == "showRelatedProcess") {
            this.$refs.processDialog.showView(
              e.data.tprocessid,
              e.data.tCanEdit
            );
          }
        });

        this.$refs.iframe.onload = () => {
          const af = this.$refs.iframe.contentWindow["AWSFormMainAPI"];
          af.customCloseFormPage(() => {
            this.isShow = false;
            return true;
          });
        };
      });
    },
    changeSize(value) {
      this.size = value;
      this.fetchList();
    },
    changePage(value) {
      this.page = value;
      this.fetchList();
    },
    readState({ row, rowIndex }) {
      if (row.readState == 0) {
        return "bold orange";
      }
      return "";
    },
  },
  watch: {
    isShow(value) {
      if (!value && this.page == 1) {
        this.fetchList();
      }
    },
  },
};
</script>

<style scoped>
.iframe {
  border: none;
  width: 100%;
  height: calc(100vh - 75px);
  overflow: auto;
}

.el-table::before {
  height: 0;
}
</style>
